export default "__VITE_ASSET__5e3561df__"